module.exports = __webpack_public_path__ + "res/13-img_game_bg_m.18d42041b14d4ce915d7e53c8c7a01b7.webp";